export default __webpack_public_path__ + "maps-examples-heatmap-example-thumbnail-480-3e1da8710f06205a6a0bd26e2914417d.png";